<app-alert></app-alert>
<!-- <ng-container *ngIf="isGreenieEnable">
  <greeenie></greeenie>
</ng-container> -->
<app-confirm></app-confirm>
<router-outlet></router-outlet>
<auth-modal></auth-modal>
<auth-modal-without-continue-logout></auth-modal-without-continue-logout>
